import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import styles from '../SkincareMainConcern.module.sass';
import ClickableDiv from '../../../../../ui_kit/clickable_div/ClickableDiv';

function Concern(props) {
  const {
    onClick, concern, isActive, color, editable, onChange, className,
  } = props;

  const inputRef = useRef(null);

  const onInputChange = (event) => {
    onChange(event.target.value);
  };

  const onClickHandler = () => {
    if (!editable && !onClick) { return; }

    if (!editable) {
      onClick();
      return;
    }

    inputRef.current.focus();
  };

  const style = {
    borderColor: color,
  };

  if (isActive) {
    style.background = color;
  }

  return (
    <ClickableDiv
      className={`${styles.block} ${isActive && styles.active} ${className}`}
      onClick={onClickHandler}
      style={style}
    >
      {!editable && concern}
      {editable && (
        <input type="text" ref={inputRef} placeholder="Other, Type Here" value={concern} onChange={onInputChange} />
      )}
    </ClickableDiv>
  );
}

Concern.propTypes = {
  onClick: PropTypes.func,
  concern: PropTypes.string.isRequired,
  isActive: PropTypes.bool.isRequired,
  color: PropTypes.string.isRequired,
  editable: PropTypes.bool,
  onChange: PropTypes.func,
  className: PropTypes.string,
};

export default Concern;
